<div class="title">
    <span>{{ data.title }}</span>
</div>
<div class="dialog-content">
    <div class="add-container">
        <app-widget-textbox [model]="newNodeName" (modelChange)="newNodeName=$event" title="{{ 'translation:Name' | i18next }}"
            placeholder="{{ 'translation:Name' | i18next }}" textboxWidth="420px"></app-widget-textbox>
    </div>
</div>
<mat-dialog-actions>
    <button mat-flat-button [ngClass]="['secondary-button']" (click)="closeDialog()">{{ 'translation:Cancel' | i18next}}</button>
    <button mat-flat-button [ngClass]="['primary-button', 'add-button-dialog']" (click)="addNode()" [disabled]="newNodeName.length > 0 ? false : true">{{data.button}}</button>
</mat-dialog-actions>